{
  "title": "News on your terms - E-paper Daily from $1.10/day",
  "body": "Instant access as and when you need it. Freedom to read when you want – no contracts, just convenience!",
  "cta": "Start reading from $1.10/day",
  "backToPublicationLink": "Not today",
  "title2": "News on your terms - E-paper Daily for $1.30/day",
  "body2": "Instant access as and when you need it. Freedom to read when you want – no contracts, just convenience! ",
  "cta2": "Start reading at $1.30/day",
  "backToPublicationLink2": "Not now"
}
